import { Star as StarIcon } from "@tamagui/lucide-icons";
import type { IntakeLandingHero } from "../../components/intake";
import { landing } from "./landingCopy";

/** The landing photo both the Natera funnel and intake routing open on. */
export const pregnancyHeroImage: IntakeLandingHero["image"] = {
  stacked: "/static/pregnancy-hero-wide.webp",
  desktop: "/static/pregnancy-hero-desktop.webp",
  stackedPosition: "50% 18%"
};
export const nateraHero: IntakeLandingHero = {
  image: pregnancyHeroImage,
  headline: landing.headline,
  stats: [landing.stats.upfront, {
    ...landing.stats.rating,
    icon: <StarIcon size="$iconSmall" color="$iconInverse" fill="currentColor" />
  }],
  trust: landing.trust
};